export enum AuthProvider {
  EMAIL = 'email',
  GOOGLE = 'google',
}
